import { render, staticRenderFns } from "./DarkFooter.vue?vue&type=template&id=05a9c0f1&scoped=true&"
import script from "./DarkFooter.vue?vue&type=script&lang=js&"
export * from "./DarkFooter.vue?vue&type=script&lang=js&"
import style0 from "./DarkFooter.vue?vue&type=style&index=0&id=05a9c0f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9c0f1",
  null
  
)

export default component.exports